<template>
  <b-modal
    ref="templateMessageAddNewModal"
    modal-class="add-modal"
    header-class="header-class"
    :hide-footer="true"
    :hide-header="!loaded"
    :size="modalSize"
    centered
    @hidden="onHide">
    <div
      v-if="!loaded"
      class="loader-25">
      <div class="loading-circle"/>
    </div>
    <iframe
      v-show="loaded"
      class="airtable-embed"
      src="https://airtable.com/embed/shr8eTmfY5IEK4olr?backgroundColor=yellow"
      frameborder="0"
      onmousewheel=""
      width="100%"
      height="100%"
      style="background: transparent; display:block; width:100%; height:85vh;"
      @load="onLoad"/>
  </b-modal>
</template>

<style lang="scss">
.add-modal {
  text-align: center;

  .modal-sm.modal-dialog-centered {
    padding-top: 0!important;
    max-width: 100px!important;

    .modal-body {
      padding: 20px!important;
    }
  }

  .modal-dialog {
    margin-left: auto;
    margin-right: auto;
  }

  .modal-dialog-centered {
    padding-top: 0!important;
  }

  .header-class {
    padding: 10px!important;

    h5 {
      margin-top: 0!important;
    }
    .close {
      z-index: 100!important;
    }
  }
}
</style>

<script>
export default {
  name: 'TemplateMessageAddNewModal',
  data() {
    return {
      loaded: false,
      modalSize: 'sm',
    };
  },
  methods: {
    show() {
      this.$refs.templateMessageAddNewModal.show();
    },
    onLoad() {
      this.loaded = true;
      this.modalSize = 'xl';
    },
    onHide() {
      this.loaded = false;
      this.modalSize = 'sm';
    },
  },
};
</script>
